import { styled } from '@mui/material/styles';
import { Tooltip } from '@mui/material';
import { tooltipClasses } from '@mui/material/Tooltip';

const WhiteTooltip = styled(({ className, ...props }) => <Tooltip {...props} classes={{ popper: className }} />)(({ theme }) => ({
    [`& .${tooltipClasses.arrow}`]: {
        color: theme.palette.common.white
    },
    [`& .${tooltipClasses.tooltip}`]: {
        backgroundColor: theme.palette.common.white,
        border: '1px solid #dadde9',
        borderRadius: 8,
        boxShadow: '0px 2px 10px rgba(24, 45, 85, 0.1)',
        minWidth: 293,
        padding: '16px 24px'
    }
}));

export default WhiteTooltip;
